import { render, staticRenderFns } from "./ChannelForm.vue?vue&type=template&id=8bc8b168"
import script from "./ChannelForm.vue?vue&type=script&lang=js"
export * from "./ChannelForm.vue?vue&type=script&lang=js"
import style0 from "./ChannelForm.vue?vue&type=style&index=0&id=8bc8b168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports